<script>
import PageHeader from "../../components/page-header";
import {
  get_partner_login,
  set_partner,
  set_partner_details,
  set_user,
  set_user_detail,
} from "../../Helper/helper";
import moment from "moment";

/**
 * Report component
 */
export default {
  components: { PageHeader },
  data() {
    return {};
  },
  methods: {
    getUser() {
      this.users = this.$auth.user;
      this.userdetail = this.$auth.setting;
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-purchase-tag"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Reports') }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
    <div class="row">
      <div class="col-12 list-table-main">
        <div class="row" v-if="$auth.partner_login">
          <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'vendor.reports.sale.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-dollar-circle"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Sales Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.All sales reports Order wise & Merchant wise for Specific date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
         <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'vendor.reports.item.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-cart"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Items Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Menu Items sales Reports based on Particular date') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <!-- end col -->
        </div>
        <div class="row" v-if="!$auth.partner_login">
          <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.customer.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-user"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Customer Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.All Active/InActive Customer report with No of Delivered Orders') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.sale.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-dollar-circle"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Sales Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.All sales reports Order wise & Merchant wise for Specific date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <!-- <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.total.earning' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-dollar"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Total Sales Vs Earning Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Order wise Admin & Merchant Earning For specific Date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div> -->
          <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.tax.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-dollar-circle"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5 class="text-truncate font-size-15">{{ trans.get('__JSON__.Tax Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Order wise Tax Reports For each Vendor for specific Date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <!-- <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.customer.credit.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-dollar-circle"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5 class="text-truncate font-size-15">{{ trans.get('__JSON__.Customer Credit Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Customer Credit Report') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div> -->

          <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.driver.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-user"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.trans('__JSON__.Driver Report',{ driver: $auth.setting.driver_name}) }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Get Drivers assigned order For specific date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.inactive.customer.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-user"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Inactive Customer Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Customers who did not placed order since 30,60 or 90 Days') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          
          <!-- <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.avg.rating.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-star"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.trans('__JSON__.Vendor - Average Feedback Report',{ vendor : $auth.setting.restaurant_name }) }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Average vendor’s rating given by customer for specific Date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div> -->
          <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.promo.code.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-dollar-circle"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Promocode Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Promo codes used by customers for specific date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <!-- <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.vendor.rating.review.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-dollar-circle"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Vendor Rating & Review Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Vendor rating & review given by customers for specific date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div> -->
          <!-- <div class="col-xl-4 col-sm-6">
            <router-link :to="{ name: 'reports.driver.rating.review.report' }">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-sm mx-auto mr-4 mt-2">
                      <span
                        class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >
                        <i class="bx bx-dollar-circle"></i>
                      </span>
                    </div>

                    <div class="media-body overflow-hidden mt-2 ml-2 report-main-p">
                      <h5
                        class="text-truncate font-size-15"
                      >{{ trans.get('__JSON__.Driver Rating & Review Report') }}</h5>
                      <p
                        class="text-muted"
                      >{{ trans.get('__JSON__.Driver rating & review given by customers for specific date range') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div> -->
          <!-- end col -->
        </div>
      </div>
    </div>
  </div>
</template>